const BACK_TO_APPLICATION = 'Back to Application'
const START_APPLICATION = 'Required Docs to Start Application'

export { BACK_TO_APPLICATION, START_APPLICATION }
